import PasswordVerification from './password-verification-container';
import PasswordVerificationView from './password-verification-view';

export default PasswordVerification;
export { PasswordVerificationView };
